import Header from "./Header";
import Footer from "./Footer";
import FloatingContact from "./FloatingContact";

export default function SiteLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#0a0a0a] text-white">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <FloatingContact />
    </div>
  );
}
